import {FC} from 'react';

import {CarouselSlideContentProps, CarouselSlideDefinition} from './carouselCommon';

/*
 * Props.
 */

interface CarouselSlideProps extends CarouselSlideContentProps {
  slide: CarouselSlideDefinition;
}

/*
 * Component.
 */

export const CarouselSlide: FC<CarouselSlideProps> = (props) => {
  const {index, slide, onPreviousClick, onNextClick, totalStepCount} = props;
  return slide.renderContent({
    index,
    onNextClick,
    onPreviousClick,
    hasComposeChannel: slide.hasComposeChannel,
    totalStepCount,
  });
};
